import { render } from "./SourceViewer.vue?vue&type=template&id=8d87ebbe&scoped=true"
import script from "./SourceViewer.vue?vue&type=script&lang=js"
export * from "./SourceViewer.vue?vue&type=script&lang=js"

import "./SourceViewer.vue?vue&type=style&index=0&id=8d87ebbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d87ebbe"]])

export default __exports__